export default {
    color: 'white',
    backgroundColor: 'red',
    padding: 20,
    marginBottom: 20,
    fontSize: 16,
};
